import axios from 'axios';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import Select from 'react-select';
import Swal from 'sweetalert2';
import enteFunciones from '../function/ente.Funcion';

const RegistrarEnteVsJefe = () => {
    const { id, idasociado } = useParams();
    const navigate = useNavigate();

    const [jefes, setJefes] = useState([]);
    const [jefeSeleccionado, setJefeSeleccionado] = useState(null);
    const [estadoAsignacion, setEstadoAsignacion] = useState('');
    const [edit, setEdit] = useState(false);

    useEffect(() => {
        setEdit(!!id);
    }, [id]);

    // Limpiar campos
    const cleanData = () => {
        setJefeSeleccionado(null);
        setEstadoAsignacion('');
    };

    // Cargar jefes al iniciar
    useEffect(() => {
        const cargarJefes = async () => {
            try {
                const jefesData = await enteFunciones.obtenerJefes();
                const jefesProcesados = jefesData.map(jefe => ({
                    ...jefe,
                    nombreJefe: [
                        jefe.nombre1Jefe,
                        jefe.nombre2Jefe,
                        jefe.apellido1Jefe,
                        jefe.apellido2Jefe
                    ].filter(Boolean).join(' ')
                }));
                setJefes(jefesProcesados);
            } catch (error) {
                console.error('Error al cargar los jefes:', error.message);
            }
        };

        cargarJefes();
    }, []);

    // Cargar datos si es modo edición
    useEffect(() => {
        const fetchAsociacion = async () => {
            try {
                const response = await axios.get(`/api/asociarjefes/listid/${idasociado}`);
                const data = response.data.asociar_asignar;

                setEstadoAsignacion(data.estadoAsignacion || '');

                const jefe = data.jefeObjectId;  // viene del populate
                if (jefe) {
                    const nombreCompletoJefe = [
                        jefe.nombre1Jefe,
                        jefe.nombre2Jefe,
                        jefe.apellido1Jefe,
                        jefe.apellido2Jefe
                    ].filter(Boolean).join(' ');

                    setJefeSeleccionado({
                        value: jefe.documentoJefe,
                        label: `CC: ${jefe.documentoJefe} - ${nombreCompletoJefe}`
                    });
                }
            } catch (error) {
                console.error('Error al cargar la asociación:', error.message);
            }
        };

        if (idasociado) {
            setEdit(true);
            fetchAsociacion();
        } else if (id) {
            setEdit(false);
            console.log('Modo creación para ente conformador', id);
        }
    }, [id, idasociado]);



    // Guardar datos
    const saveAsignacion = async () => {
        if (!jefeSeleccionado || !estadoAsignacion) {
            Swal.fire({
                icon: 'warning',
                title: 'Campos incompletos',
                text: 'Debe seleccionar un Jefe y un Estado.',
            });
            return;
        }

        try {
            const newAsignacion = {
                documentoJefe: jefeSeleccionado.value,
                estadoAsignacion
            };

            await axios.post(`/api/asociarjefes/add/${id}`, newAsignacion);
            cleanData();

            Swal.fire({
                icon: 'success',
                title: 'La asociación ha sido registrada con éxito',
                showConfirmButton: false,
                timer: 1500,
            });
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: error.response?.data?.message || 'Error al guardar la asignación',
            });
        }
    };

    const updateAsignacion = async () => {
        if (!jefeSeleccionado || !estadoAsignacion) {
            Swal.fire('Campos incompletos', 'Debe seleccionar un Jefe y un Estado.', 'warning');
            return;
        }

        try {
            const actualizacion = {
                documentoJefe: jefeSeleccionado.value,
                estadoAsignacion
            };

            await axios.put(`/api/asociarjefes/update/${idasociado}`, actualizacion);

            Swal.fire({
                icon: 'success',
                title: 'La asociación fue actualizada con éxito',
                showConfirmButton: false,
                timer: 1500
            }).then(() => {
                navigate('/enteconformador/listar');  // O usa navigate(-1) si quieres volver atrás
            });

        } catch (error) {
            Swal.fire('Error', error.response?.data?.message || 'Error al actualizar la asignación', 'error');
        }
    };



    const actions = (e) => {
        e.preventDefault();
        edit ? updateAsignacion() : saveAsignacion();
    };

    const opcionesJefes = jefes.map(jefe => ({
        value: jefe.documentoJefe,
        label: `CC: ${jefe.documentoJefe} - ${jefe.nombreJefe}`
    }));

    const opcionesEstado = [
        { value: 'Activo', label: 'Activo' },
        { value: 'Inactivo', label: 'Inactivo' }
    ];

    const handleCancelar = () => {
        cleanData();
        setEdit(false);  // opcional, si quieres salir del modo edición
        navigate('/enteconformador/listar');
    };

    return (
        <div className="container-fluid py-1 px-0 shadow-lg rounded-4 bg-light mt-2 mb-5 ">
            <h1>{edit ? 'Editar Asociación' : 'Asociar Jefes Inmediatos a EnteConformador'}</h1>

            <div className="mb-5">
                <form onSubmit={actions}>

                    <div className="container">

                        <div className="row g-3 align-items-end justify-content-center">
                            <div className="col-md-6">
                                <label className="form-label">Jefe Inmediato</label>
                                {edit ? (
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={jefeSeleccionado?.label || ''}
                                        readOnly
                                        disabled
                                    />
                                ) : (
                                    <Select
                                        options={opcionesJefes}
                                        value={jefeSeleccionado}
                                        onChange={(selectedOption) => setJefeSeleccionado(selectedOption)}
                                        placeholder="Seleccione un Jefe"
                                        isClearable
                                    />
                                )}
                            </div>


                            <div className="col-md-4">
                                <label className="form-label">Estado de Asignación</label>
                                <Select
                                    options={opcionesEstado}
                                    value={opcionesEstado.find(op => op.value === estadoAsignacion)}
                                    onChange={(selectedOption) => setEstadoAsignacion(selectedOption?.value || '')}
                                    placeholder="Seleccione un Estado"
                                    isClearable
                                />
                            </div>
                        </div>

                        <div className="row container-flex mt-3 mb-3">
                            <div className="col-md-6 d-flex justify-content-center">
                                <button type="submit" className="btn btn-success w-100">
                                    {edit ? 'Actualizar' : 'Guardar'}
                                </button>
                            </div>
                            <div className="col-md-6 d-flex justify-content-center">
                                <button type="button" className="btn btn-danger w-100" onClick={handleCancelar}>
                                    Cancelar
                                </button>
                            </div>
                        </div>

                    </div>




                </form>
            </div>


        </div>
    );
};

export default RegistrarEnteVsJefe;
